/* =============================================================================
 * Armazenamento local com namespace.
 *
 * Tudo do app fica sob o prefixo 'futigol.' para nunca colidir com outra coisa
 * no mesmo dominio. Toda leitura e' tolerante a JSON corrompido - um valor ruim
 * no storage nunca pode impedir o app de subir.
 * ========================================================================== */

const PREFIXO = 'futigol.';

function comPrefixo(chave) {
    return PREFIXO + chave;
}

function ler(area, chave, padrao) {
    try {
        const bruto = area.getItem(comPrefixo(chave));
        return bruto === null ? padrao : JSON.parse(bruto);
    } catch {
        return padrao;
    }
}

function gravar(area, chave, valor) {
    try {
        if (valor === undefined || valor === null) area.removeItem(comPrefixo(chave));
        else area.setItem(comPrefixo(chave), JSON.stringify(valor));
        return true;
    } catch {
        //Modo privativo do Safari e cota estourada caem aqui. Nao e' fatal.
        return false;
    }
}

function remover(area, chave) {
    try {
        area.removeItem(comPrefixo(chave));
    } catch {
        /* ignorado */
    }
}

export const persistente = {
    ler: (chave, padrao = null) => ler(localStorage, chave, padrao),
    gravar: (chave, valor) => gravar(localStorage, chave, valor),
    remover: (chave) => remover(localStorage, chave),
};

export const daSessao = {
    ler: (chave, padrao = null) => ler(sessionStorage, chave, padrao),
    gravar: (chave, valor) => gravar(sessionStorage, chave, valor),
    remover: (chave) => remover(sessionStorage, chave),
};

/**
 * O QUE SOBREVIVE AO LOGOUT: o que e' do APARELHO, e nao da conta.
 *
 * `instalacao` guarda se o app ja' foi instalado aqui e se a pessoa recusou o
 * convite neste aparelho (ver shared/instalacao/instalacao.js). Sair da conta
 * nao troca de celular - apagar isso faria o convite da home voltar depois de um
 * "Não, obrigado", que e' justamente o que a gravacao existe para impedir. E' o
 * mesmo criterio do identificadorConexao, que sessao.js regrava a seguir.
 */
const PRESERVAR = ['instalacao'];

/** Apaga tudo que e' do Futigol nas duas areas. Usado no logout. */
export function limparTudo() {
    const preservadas = PRESERVAR.map(comPrefixo);

    for (const area of [localStorage, sessionStorage]) {
        try {
            const chaves = Object.keys(area).filter((k) => k.startsWith(PREFIXO) && !preservadas.includes(k));
            chaves.forEach((k) => area.removeItem(k));
        } catch {
            /* ignorado */
        }
    }
}
